import { Routes } from '@angular/router';
import { HelpCenterComponent } from './page/help-center/shell/help-center/help-center.component';
import { FrequentlyAskedQuestionsComponent } from './page/faq/shell/faq.component';
import { HomeComponent } from './page/home/shell/home/home.component';

export const routes: Routes = [
  {
    path: 'central-de-ajuda',
    component: HelpCenterComponent,
    data: {
      seo: {
        title: 'Dúvidas sobre antecipação de contratos públicos? Nós ajudamos! | AntecipaGOV',
        description: 'Precisa de ajuda? Nossa Central de Ajuda tem tudo o que você precisa para antecipar seus recebíveis de contratos públicos com segurança.',
      }
    }
  },
  {
    path: 'perguntas-frequentes',
    component: FrequentlyAskedQuestionsComponent,
    data: {
      seo: {
        title: 'Como funciona o AntecipaGOV? Tire suas dúvidas aqui! | AntecipaGOV',
        description: 'Quer entender melhor como antecipar seus recebíveis de contratos públicos? Confira as perguntas mais frequentes e saiba tudo sobre o AntecipaGOV.',
      }
    },
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      seo: {
        title: 'AntecipaGOV – Crédito rápido para fornecedores do Governo',
        description:
          'Fornece para o Governo? Antecipe até 70% do seu contrato com crédito rápido e segurança na Broadfactor, plataforma oficial do AntecipaGov!',
      }
    },
  },

  {path: '', redirectTo: 'home', pathMatch: 'full'}
];
